import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";

class SiderBarMobileItem extends React.Component {
  render() {
    const { item, click, secondLevel } = this.props;
    const badgeClass = item.badge ? "sp-nav-item-badge" : "";
    const secondLevelClass = secondLevel ? "sp-nav-item-main-second" : "";
    const arrowImageSrc = require(item.open
      ? "@/assets/images/menu-arrow-up.svg"
      : "@/assets/images/menu-arrow-down.svg");
    return (
      <div
        className={`flex-row-vertical-center sp-nav-item ${
          item.active && item.path ? "sp-nav-active" : ""
        }`}
        onClick={click}
      >
        {item.path ? (
          <RouterLink
            className={`flex-row-vertical-center sp-nav-item-main ${badgeClass} ${secondLevelClass}`}
            to={item.path}
          >
            {item.imageSrc && (
              <img className="sp-nav-item-icon" src={item.imageSrc} alt="" />
            )}
            <span>{item.name}</span>
          </RouterLink>
        ) : (
          <div
            className={`flex-row-vertical-center sp-nav-item-main justify-content-between ${badgeClass} ${secondLevelClass}`}
          >
            <span>{item.name}</span>
            <img className="nav-item-arrow" src={arrowImageSrc} alt="" />
          </div>
        )}
      </div>
    );
  }
}

SiderBarMobileItem.propTypes = {
  item: PropTypes.shape({
    active: PropTypes.bool,
    badge: PropTypes.oneOfType(PropTypes.string, PropTypes.bool),
    path: PropTypes.string,
    imageSrc: PropTypes.any,
    name: PropTypes.string.isRequired,
  }).isRequired,
  click: PropTypes.func,
  secondLevel: PropTypes.bool,
};

SiderBarMobileItem.defaultProps = {
  click: undefined,
  secondLevel: false,
};

export default SiderBarMobileItem;
